import { FC, ReactNode } from 'react';

import { Box, Grid, Stack } from '@eneco/sparky';

import { SelectedProductAndService } from './SelectedProductCards';

type Props = {
  children: ReactNode;
};

export const ProductOverviewInSidebar: FC<Props> = ({ children }) => {
  return (
    <Grid
      gridTemplateColumns={{
        initial: '1fr',
        md: '1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr',
      }}
      columnGap={{ md: '8', lg: '8' }}
      gridTemplateRows={{ initial: '1fr', md: '1fr' }}>
      <Grid.Item gridColumn={{ initial: '1/-1', md: '1/7' }}>
        <Stack gap="10">{children}</Stack>
      </Grid.Item>

      <Grid.Item gridColumn={{ initial: '1/-1', md: '7/-1' }}>
        <Box paddingY="4"></Box>
        <Stack gap="4">
          <SelectedProductAndService isInSideBar={true} />
        </Stack>
      </Grid.Item>
    </Grid>
  );
};
